import { useMemo } from 'react'
import { BulkActionsProps } from '@user/components/xGrid'
import { DraftLead } from '@user/store/draftLeads'
import differenceInDays from 'date-fns/differenceInDays'

export const useBulkActionLabels = (
  selectedRows: BulkActionsProps['selectedRows'],
) => {
  const avgAge = useMemo(() => {
    const rows = [...selectedRows.entries()]

    const today = new Date()

    const totalAge = rows.reduce<number>(
      (prev, [, row]) =>
        prev +
        differenceInDays(today, new Date((row as DraftLead).createdTime)),
      0,
    )

    const avgAge = Math.floor(totalAge / rows.length)

    return `Average Age: ${avgAge} ${avgAge === 1 ? 'day' : 'days'}`
  }, [selectedRows])

  return { avgAge }
}
